import React, { useState } from 'react';
import './SupplierPortalLinks.css';

const SupplierPortalLinks = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedCategories, setExpandedCategories] = useState({
    'Cruise Lines': true,
    'Theme Parks': false,
    'Hotels & Resorts': false,
    'Airlines': false,
    'Car Rentals': false,
    'Tour Operators': false,
    'Travel Insurance': false,
    'Other Suppliers': false
  });

  const supplierCategories = {
    'Cruise Lines': [
      { name: 'Carnival Cruise Line', url: 'https://www.goccl.com', icon: '🚢' },
      { name: 'Royal Caribbean', url: 'https://www.cruisingpower.com/', icon: '🚢' },
      { name: 'Norwegian Cruise Line', url: 'https://norwegiancentral.ncl.com/', icon: '🚢' },
      { name: 'Disney Cruise Line', url: 'https://www.disneytravelagents.com', icon: '🚢' },
      { name: 'Princess Cruises', url: 'https://www.onesourcecruises.com/', icon: '🚢' },
      { name: 'Celebrity Cruises', url: 'https://www.cruisingpower.com/', icon: '🚢' },
      { name: 'MSC Cruises', url: 'https://postpaid.msccruises.com/en-gl/Personal-Area/Login.aspx', icon: '🚢' },
      { name: 'Holland America Line', url: 'https://www.halacademy.com/', icon: '🚢' },
      { name: 'Viking Cruises', url: 'https://www.viking.com/travel-advisor/welcome', icon: '🚢' },
      { name: 'Oceania Cruises', url: 'https://www.oceaniacruises.com/agent/', icon: '🚢' }
    ],
    'Theme Parks': [
      { name: 'Walt Disney World', url: 'https://www.disneytravelagents.com', icon: '🎢' },
      { name: 'Disneyland Resort', url: 'https://www.disneytravelagents.com', icon: '🎢' },
      { name: 'Universal Orlando', url: 'https://www.universalpartnercommunity.com/', icon: '🎢' },
      { name: 'Universal Studios Hollywood', url: 'https://www.universalpartnercommunity.com/', icon: '🎢' },
      { name: 'SeaWorld Parks', url: 'https://unitedparks.com/programs/travel-advisors/', icon: '🎢' },
      { name: 'Legoland', url: 'https://www.legoland.com/florida/travel-trade/', icon: '🎢' },
      { name: 'Busch Gardens', url: 'https://unitedparks.com/programs/travel-advisors/', icon: '🎢' }
    ],
    'Hotels & Resorts': [
      { name: 'Marriott Bonvoy', url: 'https://www.travelagents.marriott.com/travelagents', icon: '🏨' },
      { name: 'Hilton Hotels', url: 'https://www.hilton.com/en/portal/travel-agents/', icon: '🏨' },
      { name: 'Hyatt Hotels', url: 'https://www.hyatt.com/info/hyatt-prive', icon: '🏨' },
      { name: 'IHG Hotels', url: 'https://www.ihg.com/agent-portal', icon: '🏨' },
      { name: 'Wyndham Hotels', url: 'https://www.wyndhamhotels.com/travel-professionals', icon: '🏨' },
      { name: 'Best Western', url: 'https://www.bestwestern.com/en_US/travel-agents.html', icon: '🏨' },
      { name: 'Sandals Resorts', url: 'https://taportal.sandals.com/', icon: '🏨' },
      { name: 'Beaches Resorts', url: 'https://taportal.sandals.com/', icon: '🏨' },
      { name: 'Secrets Resorts', url: 'https://www.secretsresorts.com/travel-agents', icon: '🏨' },
      { name: 'AMResorts', url: 'https://www.amresorts.com/travel-agents', icon: '🏨' }
    ],
    'Airlines': [
      { name: 'American Airlines', url: 'https://www.aavacations.com/agent', icon: '✈️' },
      { name: 'Delta Airlines', url: 'https://pro.delta.com/', icon: '✈️' },
      { name: 'United Airlines', url: 'https://www.united.com/ual/en/us/fly/travel/agent.html', icon: '✈️' },
      { name: 'Southwest Airlines', url: 'https://www.swabiz.com/', icon: '✈️' },
      { name: 'JetBlue', url: 'https://www.jetblue.com/travel-agents', icon: '✈️' },
      { name: 'Alaska Airlines', url: 'https://www.alaskaair.com/content/travel-info/travel-agents', icon: '✈️' },
      { name: 'Spirit Airlines', url: 'https://www.spirit.com/travel-agents', icon: '✈️' },
      { name: 'Frontier Airlines', url: 'https://www.flyfrontier.com/travel/travel-agents/', icon: '✈️' }
    ],
    'Car Rentals': [
      { name: 'Enterprise', url: 'https://www.enterprise.com/en/business-car-rental/tri-branded-travel-agent.html', icon: '🚗' },
      { name: 'Hertz', url: 'https://www.hertz.com/rentacar/emember/travelAgent/login/index.jsp?targetPage=travelAgentLoginView.jsp', icon: '🚗' },
      { name: 'Avis', url: 'https://www.avis.com/en/business-programs/travel-agent', icon: '🚗' },
      { name: 'Budget', url: 'https://www.avis.com/en/business-programs/travel-agent', icon: '🚗' },
      { name: 'National Car Rental', url: 'https://www.nationalcar.com/en/reserve/travel-agent.html', icon: '🚗' },
      { name: 'Alamo', url: 'https://ta.alamo.com/en_US/travelAgent.html', icon: '🚗' },
      { name: 'Thrifty', url: 'https://www.thrifty.com/Partners/TravelAgents.aspx', icon: '🚗' },
      { name: 'Dollar', url: 'https://www.dollar.com/Partners/TravelAgents.aspx', icon: '🚗' }
    ],
    'Tour Operators': [
      { name: 'Globus', url: 'https://agents.globusfamily.com/login/', icon: '🌍' },
      { name: 'Trafalgar', url: 'https://my.trafalgar.com/', icon: '🌍' },
      { name: 'Contiki', url: 'https://my.contiki.com/', icon: '🌍' },
      { name: 'Insight Vacations', url: 'https://agents.globusfamily.com/login/', icon: '🌍' },
      { name: 'Collette', url: 'https://gateway.gocollette.com/', icon: '🌍' },
      { name: 'Tauck', url: 'https://www.tauck.co.uk/login', icon: '🌍' },
      { name: 'Gate 1 Travel', url: 'https://www.gate1travel.com/travel-agents/', icon: '🌍' },
      { name: 'Intrepid Travel', url: 'https://www.intrepidtravel.com/us/travel-agents', icon: '🌍' }
    ],
    'Travel Insurance': [
      { name: 'Allianz Global Assistance', url: 'https://agentmaxonline.com/', icon: '🛡️' },
      { name: 'Travel Guard', url: 'https://www.travelguard.com/agents-and-partners/advisor-connect', icon: '🛡️' },
      { name: 'Travelex Insurance', url: 'https://auth.travelexinsurance.com/Account/Login', icon: '🛡️' },
      { name: 'Seven Corners', url: 'https://www.sevencorners.com/about/agent', icon: '🛡️' },
      { name: 'Generali Global Assistance', url: 'https://www.generalitravelinsurance.com/travel-agents.html', icon: '🛡️' },
      { name: 'John Hancock Insurance', url: 'https://www.jhancocktravelprotection.com/agents/', icon: '🛡️' }
    ],
    'Other Suppliers': [
      { name: 'Expedia TAAP', url: 'https://www.expediataap.com/', icon: '🔑' },
      { name: 'Sabre GDS', url: 'https://www.sabre.com/', icon: '🔑' },
      { name: 'Amadeus GDS', url: 'https://servicehub.amadeus.com/', icon: '🔑' },
      { name: 'Travelport GDS', url: 'https://eportal.travelport.com/', icon: '🔑' },
      { name: 'Viator', url: 'https://partners.viator.com/login', icon: '🎫' },
      { name: 'GetYourGuide', url: 'https://www.getyourguide.agency/', icon: '🎫' },
      { name: 'Klook', url: 'https://www.klook.com/en-US/partners/', icon: '🎫' }
    ]
  };

  const toggleCategory = (category) => {
    setExpandedCategories(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  const expandAll = () => {
    const allExpanded = {};
    Object.keys(supplierCategories).forEach(cat => {
      allExpanded[cat] = true;
    });
    setExpandedCategories(allExpanded);
  };

  const collapseAll = () => {
    const allCollapsed = {};
    Object.keys(supplierCategories).forEach(cat => {
      allCollapsed[cat] = false;
    });
    setExpandedCategories(allCollapsed);
  };

  const filterSuppliers = () => {
    if (!searchTerm) return supplierCategories;

    const filtered = {};
    Object.keys(supplierCategories).forEach(category => {
      const matchingSuppliers = supplierCategories[category].filter(supplier =>
        supplier.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      if (matchingSuppliers.length > 0) {
        filtered[category] = matchingSuppliers;
      }
    });
    return filtered;
  };

  const filteredCategories = filterSuppliers();

  return (
    <div className="supplier-portal-links">
      <div className="supplier-portal-header">
        <h1>🔗 Supplier Portal Links</h1>
        <p>Quick access to all your travel supplier agent portals</p>
      </div>

      <div className="supplier-portal-controls">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search suppliers..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="supplier-search-input"
          />
          {searchTerm && (
            <button 
              className="clear-search-btn"
              onClick={() => setSearchTerm('')}
              aria-label="Clear search"
            >
              ✕
            </button>
          )}
        </div>
        <div className="expand-collapse-btns">
          <button onClick={expandAll} className="expand-btn">Expand All</button>
          <button onClick={collapseAll} className="collapse-btn">Collapse All</button>
        </div>
      </div>

      <div className="supplier-categories">
        {Object.keys(filteredCategories).length === 0 ? (
          <div className="no-results">
            <p>No suppliers found matching "{searchTerm}"</p>
          </div>
        ) : (
          Object.keys(filteredCategories).map(category => (
            <div key={category} className="supplier-category">
              <div 
                className="category-header"
                onClick={() => toggleCategory(category)}
              >
                <h2>
                  <span className={`expand-icon ${expandedCategories[category] ? 'expanded' : ''}`}>
                    ▶
                  </span>
                  {category}
                  <span className="supplier-count">({filteredCategories[category].length})</span>
                </h2>
              </div>
              
              {expandedCategories[category] && (
                <div className="supplier-links-grid">
                  {filteredCategories[category].map(supplier => (
                    <a
                      key={supplier.name}
                      href={supplier.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="supplier-link-btn"
                    >
                      <span className="supplier-icon">{supplier.icon}</span>
                      <span className="supplier-name">{supplier.name}</span>
                      <span className="external-link-icon">↗</span>
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))
        )}
      </div>

      <div className="supplier-portal-footer">
        <p className="footer-note">
          💡 <strong>Tip:</strong> Bookmark this page for quick access to all your supplier portals. 
          If you notice any broken links or missing suppliers, please contact support.
        </p>
      </div>
    </div>
  );
};

export default SupplierPortalLinks;
